// To format input to $1,000.00
export function CurrencyFormatDirective(UtilService, $filter) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      let utils = new UtilService(scope);
      utils.validatePattern(element, 'currency');

      let decimals = attrs.currencyFormat ? attrs.currencyFormat : 2;

      // Saved to your $scope/model
      function toModel(value) {
        return parseFloat(value.toString().replace(/[^0-9._-]/g, ''));
      }

      // Displayed in the input to users - mask
      function toView(value) {
        return $filter('currency')(value, '', decimals); // amount, symbol, decimals
      }

      ngModel.$formatters.push(toView);
      ngModel.$parsers.push(toModel);

      element.bind('blur', function () {
        ngModel.$viewValue = toView(ngModel.$modelValue);
        ngModel.$render();
      });
    },
  };
}

CurrencyFormatDirective.$inject = ['UtilService', '$filter'];
